import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import {FormsModule, ReactiveFormsModule} from '@angular/forms'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FullComponent } from './layouts/full/full.component';
import { HeaderComponent } from './layouts/full/header/header.component';
import { DemoFlexyModule } from './demo-flexy-module'
import { ComponentsModule } from './pages/components.module';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {AuthInterceptor} from '../shared/interceptors/auth.interceptor';
import {SokratesSsoScriptService} from '../shared/services/sokrates-sso-script.service';
import { ExtracurricularService } from "../shared/services/extracurricular.service";
import { SettingService } from "../shared/services/setting.service";
import { LocalStorageService } from "../shared/services/localstorage.service";
import { AcademicCalendarService } from "../shared/services/academic-calendar.service";
import { ToastrService, ToastrModule } from "ngx-toastr";
import {YearLevelMappingService} from "../shared/services/year-level-mapping.service";
import {AuthService} from "../shared/services/auth.service";
import {TranslateService} from "../shared/services/translate.service";
import {SchoolAndLocationService} from "../shared/services/school-and-location.service";
import {LoginComponent} from "./authentication/side-login/login.component";
import {NgOtpInputComponent} from "ng-otp-input";
import {UserService} from "../shared/services/user.service";
import {WebsiteService} from "../shared/services/website.service";
import {WINDOW} from "../shared/providers/window.provider";
import {AuthComponent} from "./authentication/auth.component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ExtracurricularCategoryService} from "../shared/services/extracurricular-category.service";
import {ExtracurricularRuleService} from "../shared/services/extracurricular-rule.service";
import {MatTableModule} from "@angular/material/table";
import {SchoolProgramModule} from "./pages/school-program/school-program.module";
import {PathwayMappingService} from "../shared/services/pathway-mapping.service";
import {ClassService} from "../shared/services/class.service";
import {SchoolProgramService} from "../shared/services/school-program.service";
import {ActivityModule} from "./pages/activity/activity.module";
import {PeriodService} from "../shared/services/period.service";
import { RegistrationService } from 'src/shared/services/registration.service';
import { OnlineRegistrationModule } from './pages/online-registration/online-registration.module';
import { ActivityListComponent } from './pages/activity/activity-list/activity-list.component';
import {
    SelectAcademicYearOnlyModule
} from "../shared/modules/select-academic-year-only/select-academic-year-only.module";
import { RegistrationApproverModule } from './pages/registration-approver/registration-approver.module';
import { AttendanceModule } from './pages/attendance/attendance.module';
import { AttendanceService } from 'src/shared/services/attendance.service';
import { AttendanceListModule } from './pages/attendance-list/attendance-list.module';
import { CoachModule } from './pages/coach/coach.module';
import { CoachService } from 'src/shared/services/coach.service';
import { ScoringModule } from './pages/scoring/scoring.module';
import { ScoringService } from 'src/shared/services/scoring.service';
import { BlockedComponent } from './blocked/blocked/blocked.component';
import { ServerSelectComponent } from './server-select/server-select.component';
import { ActivityApproverModule } from './pages/activity-approver/activity-approver.module';
import { ResponseService } from 'src/shared/services/response-service.service';
import { RegistrationPaymentModule } from './pages/registration-payment/registration-payment.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { ApproverSetupModule } from './pages/approver-setup/approver-setup.module';
import { PeriodSetupModule } from './pages/period-setup/period-setup.module';
import { SetupService } from 'src/shared/services/setup.service';
import { PaymentVaModule } from './pages/payment-va/payment-va.module';
import { RegistrationPaymentService } from 'src/shared/services/registration-payment.service';
import { RulesService } from 'src/shared/services/rules.service';
import { DashboardService } from 'src/shared/services/dashboard.service';
import { PaymentStudentModule } from './pages/payment-student/payment-student.module';
import { SchoolProgramRulesModule } from './pages/school-program-rules/school-program-rules.module';
import { ReportUnregisteredModule } from './pages/report-unregistered/report-unregistered.module';
import { ReportRegisteredModule } from './pages/report-registered/report-registered.module';
import { SokratesSsoButtonComponent } from './authentication/side-login/sokrates-sso-button.component';
import { SsoCallbackComponent } from './authentication/sso-callback/sso-callback.component';

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
      HeaderComponent,
      AuthComponent,
      LoginComponent,
      ServerSelectComponent,
      SokratesSsoButtonComponent,
      SsoCallbackComponent,
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FeatherModule.pick(allIcons),
        DemoFlexyModule,
        ComponentsModule,
        FormsModule,
        HttpClientModule,
        ToastrModule.forRoot(),
        ReactiveFormsModule,
        NgOtpInputComponent,
        FontAwesomeModule,
        MatTableModule,
        DashboardModule,
        OnlineRegistrationModule,
        RegistrationApproverModule,
        SchoolProgramModule,
        ActivityModule,
        SelectAcademicYearOnlyModule,
        AttendanceModule,
        AttendanceListModule,
        CoachModule,
        ScoringModule,
        FormsModule,
        ActivityApproverModule,
        ApproverSetupModule,
        PeriodSetupModule,
        RegistrationPaymentModule,
        PaymentVaModule,
        PaymentStudentModule,
        SchoolProgramRulesModule,
        ReportUnregisteredModule,
        ReportRegisteredModule
    ],
  providers: [ ExtracurricularService,
    SettingService,
    LocalStorageService,
    HttpClient,
    AcademicCalendarService,
    ToastrService,
    YearLevelMappingService,
    AuthService,
    TranslateService,
    SchoolAndLocationService,
    UserService,
    WebsiteService,
    ExtracurricularCategoryService,
      ExtracurricularRuleService,
      PathwayMappingService,
      ClassService,
      SchoolProgramService,
      PeriodService,
      RegistrationService,
      AttendanceService,
      CoachService,
      ScoringService,
      ResponseService,
      SetupService,
      RegistrationPaymentService,
      RulesService,
      DashboardService,
    { provide: WINDOW, useValue: window },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      // Keeps a switch-in from another app (?sso_switch=1) before the redirects drop the query,
      // starts loading the SSO SDK, and reads Enforce SSO for this product.
      provide: APP_INITIALIZER,
      useFactory: (ssoScript: SokratesSsoScriptService) => () => {
        ssoScript.captureSwitchIn();
        ssoScript.preload();
        // Routing waits for Enforce SSO (bounded by a timeout): the login page depends on it.
        return ssoScript.loadEnforce();
      },
      deps: [SokratesSsoScriptService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
